/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';
import {BaseCardFragment} from '@amblique/contentful/app/contentful/fragments/card/base-card.fragment';
import {BaseCarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/base-carousel.fragment';
import {BaseHotspotContentFragment} from '@amblique/contentful/app/contentful/fragments/hotspot-content/base-hotspot-content.fragment';

export const ShopTheLookFragment = gql`
  ${BaseCardFragment}
  ${BaseCarouselFragment}
  ${BaseHotspotContentFragment}
  ${BaseShopTheLookFragment}

  fragment ShopTheLookFragment on ShopTheLook {
    ...BaseShopTheLookFragment

    hotspotsContentCollection {
      items {
        __typename
        ... on Card {
          ...BaseCardFragment
        }
        ... on Carousel {
          ...BaseCarouselFragment
        }
        ... on HotspotContent {
          ...BaseHotspotContentFragment
        }
      }
    }
    hotspotsContentCursorCollection {
      items {
        __typename
        ... on Card {
          ...BaseCardFragment
        }
        ... on Carousel {
          ...BaseCarouselFragment
        }
        ... on HotspotContent {
          ...BaseHotspotContentFragment
        }
      }
    }
    shopTheLookRichText: text {
      json
    }
  }
`;
